import React from 'react';
import Menu from './Menu';
import { Link } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import '../css/header.css';
import '../css/menu-button.css';

function Header(props) {
  //transition and fixed menu while switching menu

  return (
    <TransitionGroup>
      <CSSTransition key='header' timeout={300} classNames='header'>
        <header id='header' className={`${props.showMenu ? 'absolute' : ''}`}>
          <div className='main-header'>
            <div
              onClick={() => {
                props.setOpenMenu(!props.openMenu);
                console.log(props.openMenu);
              }}
              className={`menu-button ${props.openMenu ? 'open' : ''} ${
                props.showMenu ? 'show-menu' : ''
              }`}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <Link
              onClick={e => {
                props.setOpenMenu(false);
                props.setSelected('home');
              }}
              to='/homepage'
              className={props.showMenu ? 'unclickable' : ''}
            >
              <img
                className='logo'
                src='./logo3.png'
                alt='jamie-sparker-logo'
              />
            </Link>
          </div>
          <Menu
            openMenu={props.openMenu}
            setOpenMenu={props.setOpenMenu}
            selected={props.selected}
            setSelected={props.setSelected}
          />
        </header>
      </CSSTransition>
    </TransitionGroup>
  );
}

export default Header;
